// extracted by mini-css-extract-plugin
module.exports = {"section":"FeaturePosts_section__Kai3I","box":"FeaturePosts_box__D_YAg","head":"FeaturePosts_head___eaWd"};